const SETTING_FEE_RATE_LOADING = 'SETTING_FEE_RATE_LOADING';
const SETTING_FEE_RATE_SUCCESS = 'SETTING_FEE_RATE_SUCCESS';
const SETTING_FEE_RATE_FAILURE = 'SETTING_FEE_RATE_FAILURE';

export const settingFeeRateActions = {
  SETTING_FEE_RATE_LOADING,
  SETTING_FEE_RATE_SUCCESS,
  SETTING_FEE_RATE_FAILURE,
};
